import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "detail_container p-relative" }
const _hoisted_2 = {
  key: 0,
  class: "leftAlign",
  ref: "boxContainer"
}
const _hoisted_3 = { class: "post-detail-container" }
const _hoisted_4 = { class: "post--content" }
const _hoisted_5 = { class: "body" }
const _hoisted_6 = { class: "post-detail-container" }
const _hoisted_7 = { class: "post--content" }
const _hoisted_8 = { class: "body" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = {
  key: 0,
  class: "SignalCardInfoDv PostDetailSignalCardDv"
}
const _hoisted_11 = {
  key: 1,
  class: "postDetailNoData"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PostInfoComponent = _resolveComponent("PostInfoComponent")!
  const _component_PostProfile = _resolveComponent("PostProfile")!
  const _component_PostTextComponent = _resolveComponent("PostTextComponent")!
  const _component_PostSectionSelectionPreviewComponent = _resolveComponent("PostSectionSelectionPreviewComponent")!
  const _component_PostMediaComponent = _resolveComponent("PostMediaComponent")!
  const _component_PostMetaComponent = _resolveComponent("PostMetaComponent")!
  const _component_FeedCandleChart = _resolveComponent("FeedCandleChart")!
  const _component_WatchlistContainerComponent = _resolveComponent("WatchlistContainerComponent")!
  const _component_PredictionContainerComponent = _resolveComponent("PredictionContainerComponent")!
  const _component_SignalCardItem = _resolveComponent("SignalCardItem")!
  const _component_PostSectionSelectionRelationPreviewComponent = _resolveComponent("PostSectionSelectionRelationPreviewComponent")!
  const _component_PortfolioTradePostingCardComponent = _resolveComponent("PortfolioTradePostingCardComponent")!
  const _component_PostPreviewComponent = _resolveComponent("PostPreviewComponent")!
  const _component_PostCardComponent = _resolveComponent("PostCardComponent")!
  const _component_PostCommentComponent = _resolveComponent("PostCommentComponent")!
  const _component_PostReactionComponent = _resolveComponent("PostReactionComponent")!
  const _component_IconComponent = _resolveComponent("IconComponent")!

  return (_ctx.post)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["post_detail", [_ctx.isEnlargeView ? 'enlargen' : '', _ctx.fromOutside ? 'fromOutside' : '']])
      }, [
        _createElementVNode("div", {
          class: "modal--backdrop",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
        }),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", {
            class: "clickDv",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
          }),
          (_ctx.post.type == 'repost' && !_ctx.post?.media?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_PostInfoComponent, {
                    fromProfilePostCard: false,
                    post: _ctx.post
                  }, null, 8, ["post"]),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_PostProfile, {
                      user: _ctx.postUser,
                      addPostModel: _ctx.post,
                      postSubType: _ctx.post.postSubType,
                      postType: _ctx.post.type,
                      postPrivacy: _ctx.post.postPrivacy,
                      postId: _ctx.post._id,
                      onAvatarClick: _ctx.handleAvatarClick
                    }, null, 8, ["user", "addPostModel", "postSubType", "postType", "postPrivacy", "postId", "onAvatarClick"]),
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_PostTextComponent, { post: _ctx.post }, null, 8, ["post"])
                    ])
                  ])
                ]),
                _cache[3] || (_cache[3] = _createElementVNode("div", {
                  id: `teleport-post`,
                  class: "teleport-post"
                }, null, -1))
              ], 512))
            : _createCommentVNode("", true),
          (_ctx.post.type != 'repost')
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(["leftAlign", {
          cardCenterAlign: _ctx.post.type == 'text',
          image:
            _ctx.post.type == 'media' || (_ctx.post.metaData && _ctx.post.metaData.length),
          pagedView: _ctx.post.type === 'text' && _ctx.post.postSubType === 'page',
        }]),
                ref: "boxContainer"
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_PostInfoComponent, {
                    fromProfilePostCard: false,
                    post: _ctx.post
                  }, null, 8, ["post"]),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_PostProfile, {
                      user: _ctx.postUser,
                      addPostModel: _ctx.post,
                      postSubType: _ctx.post.postSubType,
                      fromOutside: _ctx.fromOutside,
                      postType: _ctx.post.type,
                      postPrivacy: _ctx.post.postPrivacy,
                      postId: _ctx.post._id,
                      onAvatarClick: _ctx.handleAvatarClick
                    }, null, 8, ["user", "addPostModel", "postSubType", "fromOutside", "postType", "postPrivacy", "postId", "onAvatarClick"]),
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_PostTextComponent, {
                        post: _ctx.post,
                        isDetailView: true,
                        hideQuoted: !!_ctx.post.quotedImage
                      }, null, 8, ["post", "hideQuoted"])
                    ])
                  ])
                ]),
                (_ctx.shouldShowDetailBox)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      style: _normalizeStyle([{"flex-direction":"column"}, _ctx.boxStyle]),
                      class: _normalizeClass(["box_detail_container", { quotedDetailBox: !!_ctx.post.quotedImage }])
                    }, [
                      (_ctx.post.quotedImage)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "detail-quoted-card text_post quotedText",
                            style: _normalizeStyle(_ctx.getQuotedStyle(_ctx.post.quotedImage))
                          }, [
                            _createElementVNode("div", {
                              class: "post_message description_text expanded",
                              innerHTML: _ctx.quotedDisplayText
                            }, null, 8, _hoisted_9)
                          ], 4))
                        : _createCommentVNode("", true),
                      (_ctx.post.type === 'profile' && _ctx.post.postSubType == 'highlights')
                        ? (_openBlock(), _createBlock(_component_PostSectionSelectionPreviewComponent, {
                            key: 1,
                            post: _ctx.post,
                            fromOutside: _ctx.fromOutside,
                            class: "post-profile-section"
                          }, null, 8, ["post", "fromOutside"]))
                        : _createCommentVNode("", true),
                      (_ctx.post.media && _ctx.post.media.length)
                        ? (_openBlock(), _createBlock(_component_PostMediaComponent, {
                            key: 2,
                            media: _ctx.post.media,
                            isDetailView: true
                          }, null, 8, ["media"]))
                        : _createCommentVNode("", true),
                      (_ctx.post.metaData && _ctx.post.metaData.length)
                        ? (_openBlock(), _createBlock(_component_PostMetaComponent, {
                            key: 3,
                            meta: _ctx.post.metaData
                          }, null, 8, ["meta"]))
                        : _createCommentVNode("", true),
                      (_ctx.post.type == 'charts' || _ctx.post.postSubType == 'charts')
                        ? (_openBlock(), _createBlock(_component_FeedCandleChart, {
                            key: 4,
                            post: _ctx.post
                          }, null, 8, ["post"]))
                        : _createCommentVNode("", true),
                      (_ctx.post.type == 'analysis' && _ctx.post.postSubType == 'watchlist')
                        ? (_openBlock(), _createBlock(_component_WatchlistContainerComponent, {
                            key: 5,
                            postModel: _ctx.post,
                            className: "postDetails boardPost",
                            isDetailView: true
                          }, null, 8, ["postModel"]))
                        : _createCommentVNode("", true),
                      (
              _ctx.post.type == 'analysis' &&
              _ctx.post.postSubType == 'prediction' &&
              _ctx.post.prediction &&
              _ctx.post.prediction.length
            )
                        ? (_openBlock(), _createBlock(_component_PredictionContainerComponent, {
                            key: 6,
                            postModel: _ctx.post,
                            className: "boardPost detailviewinfoDVanalysis"
                          }, null, 8, ["postModel"]))
                        : _createCommentVNode("", true),
                      (_ctx.post.type === 'analysis' && _ctx.post.postSubType == 'signal')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                            (_ctx.post.signal)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                  _createVNode(_component_SignalCardItem, {
                                    class: "CreatePostSignalInfo",
                                    addPostModelDv: _ctx.post.signal
                                  }, null, 8, ["addPostModelDv"])
                                ]))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true),
                      (_ctx.post.type === 'profile' && _ctx.post.postSubType == 'relations')
                        ? (_openBlock(), _createBlock(_component_PostSectionSelectionRelationPreviewComponent, {
                            key: 8,
                            post: _ctx.post,
                            class: "postDetailinfoDvRelationDv",
                            onOnProfileClicked: _ctx.closeModal,
                            fromOutside: _ctx.fromOutside
                          }, null, 8, ["post", "onOnProfileClicked", "fromOutside"]))
                        : _createCommentVNode("", true),
                      (_ctx.post.type === 'portfolio' && _ctx.post.postSubType == 'trade')
                        ? (_openBlock(), _createBlock(_component_PortfolioTradePostingCardComponent, {
                            key: 9,
                            class: "TradeInfoDv",
                            trade: _ctx.post.trade,
                            stock: _ctx.post.stockTags[0]
                          }, null, 8, ["trade", "stock"]))
                        : _createCommentVNode("", true),
                      (_ctx.post.type === 'text' && _ctx.post.postSubType === 'page')
                        ? (_openBlock(), _createBlock(_component_PostPreviewComponent, {
                            key: 10,
                            "show-edit-dropdown": false,
                            type: _ctx.postData?.type,
                            content: _ctx.postData?.data || false,
                            "current-page": _ctx.postData?.pageNumber,
                            "total-pages": _ctx.post.pagePostData?.length || 1,
                            value: _ctx.postData?.pageNumber || 1,
                            "onUpdate:value": _ctx.setPage,
                            isDetailView: true
                          }, null, 8, ["type", "content", "current-page", "total-pages", "value", "onUpdate:value"]))
                        : _createCommentVNode("", true)
                    ], 6))
                  : _createCommentVNode("", true)
              ], 2))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            ref: "commentList",
            class: _normalizeClass(["rightAlign postDetailsWrapper", {
          pagedView:
            (_ctx.post.media && _ctx.post.media.length) ||
            (_ctx.post.type === 'text' && _ctx.post.postSubType === 'page'),
        }])
          }, [
            _createVNode(_component_PostCardComponent, {
              onCloseModal: _ctx.closeModal,
              ref: "cardArea",
              post: _ctx.post,
              class: _normalizeClass(["PostDetailCardPreviewDv", { isDetailView: _ctx.isOnlyTextPost }]),
              isDetailView: !_ctx.isMobileView,
              showImageViewer: true,
              fromOutside: _ctx.fromOutside,
              postingData: _ctx.postingData
            }, null, 8, ["onCloseModal", "post", "class", "isDetailView", "fromOutside", "postingData"]),
            (!_ctx.fromOutside)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_ctx.isCommentView)
                    ? (_openBlock(), _createBlock(_component_PostCommentComponent, {
                        key: 0,
                        ref: "commentSection",
                        postType: _ctx.post.type,
                        sourceId: _ctx.post._id,
                        sourceType: "post"
                      }, null, 8, ["postType", "sourceId"]))
                    : (_openBlock(), _createBlock(_component_PostReactionComponent, {
                        key: 1,
                        style: _normalizeStyle(_ctx.getRightAlignStyle),
                        sourceId: _ctx.post._id,
                        sourceType: "post"
                      }, null, 8, ["style", "sourceId"]))
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.fromOutside)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_component_IconComponent, {
                    class: "iconinfoNoDataFoundDv",
                    icon: "infoIconNoData.svg"
                  }),
                  _cache[4] || (_cache[4] = _createElementVNode("h2", null, "Join the Conversation", -1)),
                  _cache[5] || (_cache[5] = _createElementVNode("p", null, "Sign in to view likes and comments.", -1)),
                  _createElementVNode("button", {
                    class: "btn btn--primary",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openPublicSignInDialog()))
                  }, " Sign In ")
                ]))
              : _createCommentVNode("", true)
          ], 2)
        ])
      ], 2))
    : _createCommentVNode("", true)
}